module.exports = __webpack_public_path__ + "media/images/top/works09-dd8cf9bfa26964bd0dfca315d44e5598.jpg";